const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const PaylensQuery = {
    GetEmbedToken: Backofficebff + '/v1/paylens/embed-token',
};
